module.exports = __webpack_public_path__ + "static/media/terroir.9d95256a.jpg";